module.exports = __webpack_public_path__ + "static/media/css.d0a3a885.jpg";